/* ============================================================
   CULT RACING — OUTRUN (cr-chase)
   The header game that gates a drop page.

   A bike out front, a cruiser behind. Each question answered
   right pulls the bike away; each one wrong lets the cruiser
   close. Reach the far side of the meter and the rack unlocks.
   Hit zero and it is a pull-over: run it back from the start.

   Inert without #chase on the page. The scene is a 320x160
   canvas drawn with plain rects and arcs, scaled up pixelated,
   so it costs no image request and no library. The questions
   are ordinary buttons in ordinary HTML, so they work with a
   screen reader and at any zoom; only the picture is canvas.

   The gate lives on <html data-chase="locked|open">, set by
   script only, so a visitor without JavaScript never meets it.
   An escape is remembered per collection in localStorage, so a
   returning buyer is not quizzed twice on the same drop.
   ============================================================ */
(function () {
  "use strict";

  var root = document.getElementById("chase");
  if (!root) return;

  var html = document.documentElement;
  var KEY = "cr-chase:" + (root.getAttribute("data-chase-key") || "drop");
  var reduce = !!(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);
  // game-only page: an escape leads to the winner sign-up, not a rack
  var winner = root.hasAttribute("data-chase-winner");
  // game + password page (2026-09-24): an escape does NOT open the rack. It
  // hands over the drop password, which the visitor types into the password
  // screen beside the game; only the password opens the rack, so this script
  // never touches html[data-chase] in this mode. The word arrives base64 in
  // data-chase-reward. Honest limit: it is in the page source for anyone who
  // looks; the game is a door for the crowd, not a lock.
  var reward = "";
  try { reward = root.hasAttribute("data-chase-reward") ? atob(root.getAttribute("data-chase-reward")) : ""; } catch (e) { reward = ""; }
  function gate(state) { if (!reward) html.setAttribute("data-chase", state); }

  /* ---------- tuning ---------- */
  var START = 2;       // gap you set off with
  var WIN = 5;         // gap that counts as gone
  var LOSE = 0;        // gap that counts as pulled over
  var TIME = 10000;    // ms per question; the fuse runs out = wrong
  var PICK = 3;        // answers shown per question

  /* ---------- the question bank ----------
     Brand and Instagram facts only, each one checked against the store or the
     Instagram API on the day it was written; nothing here is guessed. Counts
     that move (followers) are written as "closest to" so they age honestly.
     `c` is the index of the right answer. Options are shuffled on screen. */
  var BANK = [
    { q: "How many followers does @thecultracing have on Instagram?",
      a: ["About 16K", "About 116K", "About 1.1M"], c: 1 },
    { q: "What does the bio on @thecultracing say?",
      a: ["Cult Racing VS Everybody", "Real Ones Only", "Race Or Die"], c: 0 },
    { q: "What day of the week do Cult Racing drops open?",
      a: ["Friday", "Saturday", "Monday"], c: 0 },
    { q: "What time do the drops open?",
      a: ["12 PM Eastern", "9 AM Eastern", "Midnight Eastern"], c: 0 },
    { q: "Who runs Cult Racing?",
      a: ["McLaren Daddy", "Lambo Papa", "Porsche Pops"], c: 0 },
    { q: "What does a Cult Racing hoodie go for?",
      a: ["$99.13", "$89.99", "$120.00"], c: 0 },
    { q: "What does a Cult Racing tee go for?",
      a: ["$45.13", "$39.99", "$60.00"], c: 0 },
    { q: "Which of these is a real Cult Racing design?",
      a: ["Snitches Get Stitches", "Winners Never Quit", "Live Laugh Race"], c: 0 },
    { q: "Finish the line: No Plate, No ___",
      a: ["Case", "Problem", "Race"], c: 0 },
    { q: "Finish the line: Shut Up And ___",
      a: ["Race", "Drive", "Send It"], c: 0 },
    { q: "Finish the line: Death Before ___",
      a: ["Detained", "Dishonor", "Defeat"], c: 0 },
    { q: "Finish the drop name: Talk Shit, ___",
      a: ["Get Hit", "Get Lit", "Get Left"], c: 0 },
    { q: "What happens to a design once its drop closes?",
      a: ["It stays archived. For good.", "It restocks the next month", "It goes on sale"], c: 0 },
    { q: "How many members does Cult Racing say it has worldwide?",
      a: ["100,000+", "10,000+", "1,000+"], c: 0 },
    { q: "The Cult Racing wordmark is written in what style?",
      a: ["Blackletter", "Bubble letters", "Cursive script"], c: 0 },
    { q: "Which accessory has been in every Cult Racing drop?",
      a: ["The shiesty", "A belt buckle", "A lanyard"], c: 0 },
    { q: "Which of these was a real Cult Racing drop?",
      a: ["Unregistered", "Registered", "Licensed"], c: 0 },
    { q: "Finish the tagline: Cult over ___",
      a: ["Clout", "Everything", "Everybody"], c: 0 },
    { q: "Finish the line: We don't follow trends. We build ___",
      a: ["Crews", "Cars", "Brands"], c: 0 }
  ];

  /* ---------- storage, which may be walled off in a webview ---------- */
  var store = {
    get: function () { try { return localStorage.getItem(KEY) === "1"; } catch (e) { return false; } },
    set: function () { try { localStorage.setItem(KEY, "1"); } catch (e) { /* in-memory only */ } }
  };

  function track(name, extra) {
    var d = { event: "chase_" + name };
    if (extra) for (var k in extra) d[k] = extra[k];
    try { document.dispatchEvent(new CustomEvent("cr:chase", { detail: d })); } catch (e) {}
    if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(d);
  }

  /* ---------- markup ---------- */
  root.innerHTML =
    '<div class="chase__scene">' +
      '<canvas class="chase__canvas" width="320" height="160" aria-hidden="true"></canvas>' +
      '<div class="chase__hud" aria-hidden="true"><span>Gap</span><span class="chase__meter"></span></div>' +
      '<div class="chase__stamp" aria-hidden="true"><span></span></div>' +
    '</div>' +
    '<div class="chase__panel">' +
      '<p class="chase__sr" aria-live="assertive"></p>' +
      '<div data-view="intro">' +
        '<p class="chase__kicker">Unlock the drop</p>' +
        '<h2 class="chase__title">Outrun the cops</h2>' +
        '<p class="chase__copy">Right answers pull you away. Wrong ones let them close in. ' + (winner ? 'Get away and you are on the list for the password.' : reward ? 'Get away and the password is yours.' : 'Get away and the rack is yours.') + '</p>' +
        '<div class="chase__actions"><button type="button" class="btn btn--primary" data-start><span>Start the run</span></button></div>' +
      '</div>' +
      '<div data-view="q" hidden>' +
        '<div class="chase__row"><span data-qn></span><div class="chase__timer"><i></i></div></div>' +
        '<p class="chase__question" data-q></p>' +
        '<div class="chase__answers" data-answers></div>' +
      '</div>' +
      '<div data-view="result" hidden>' +
        '<p class="chase__kicker" data-rk></p>' +
        '<h2 class="chase__title" data-rt></h2>' +
        '<p class="chase__reward" data-reward hidden><span class="chase__reward-label">Password</span><strong data-reward-word></strong></p>' +
        '<p class="chase__copy" data-rc></p>' +
        '<div class="chase__actions">' +
          '<button type="button" class="btn btn--primary" data-again><span>Run it back</span></button>' +
          '<a href="' + (winner ? '#winner' : reward ? '#gate' : '#rack') + '" class="btn btn--primary" data-shop hidden><span>' + (winner ? 'Lock in your spot' : reward ? 'Enter it' : 'Shop the drop') + '</span></a>' +
          '<button type="button" class="chase__again" data-replay hidden>Run it again</button>' +
        '</div>' +
      '</div>' +
    '</div>';

  var $ = function (sel) { return root.querySelector(sel); };
  var views = { intro: $('[data-view="intro"]'), q: $('[data-view="q"]'), result: $('[data-view="result"]') };
  var el = {
    canvas: $(".chase__canvas"), meter: $(".chase__meter"), stamp: $(".chase__stamp"),
    stampText: $(".chase__stamp span"), sr: $(".chase__sr"),
    qn: $("[data-qn]"), timer: $(".chase__timer"), fuse: $(".chase__timer i"),
    q: $("[data-q]"), answers: $("[data-answers]"),
    rk: $("[data-rk]"), rt: $("[data-rt]"), rc: $("[data-rc]"),
    reward: $("[data-reward]"), rewardWord: $("[data-reward-word]"),
    start: $("[data-start]"), again: $("[data-again]"), shop: $("[data-shop]"), replay: $("[data-replay]")
  };
  for (var i = 0; i < WIN; i++) el.meter.appendChild(document.createElement("i"));

  function show(name) {
    for (var k in views) views[k].hidden = (k !== name);
  }

  /* ============================================================
     THE SCENE
     ============================================================ */
  var ctx = el.canvas.getContext("2d");
  var W = 320, H = 160, GY = 132;          // ground line
  var BIKE_X = 214;                        // rear axle of the bike
  var scene = {
    t: 0, odo: 0, speed: 3, road: 0, sky: 0, far: 0,
    copX: 0, copTarget: 0, bikeX: BIKE_X, bikeVX: 0,
    boost: 0, siren: 0, tint: 0, mode: "run", raf: 0, last: 0
  };
  var skyline = [];
  (function () {
    var x = 0, seed = 7;
    var rnd = function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
    while (x < W * 2) {
      var w = 10 + Math.floor(rnd() * 22), h = 8 + Math.floor(rnd() * 34);
      skyline.push({ x: x, w: w, h: h }); x += w + 2 + Math.floor(rnd() * 8);
    }
  })();
  ctx.imageSmoothingEnabled = false;

  function copFor(gap) { return BIKE_X - 10 - gap * 46; }   // front bumper x

  function px(x, y, w, h, c) { ctx.fillStyle = c; ctx.fillRect(Math.round(x), Math.round(y), w, h); }
  function disc(x, y, r, c) { ctx.fillStyle = c; ctx.beginPath(); ctx.arc(Math.round(x), Math.round(y), r, 0, Math.PI * 2); ctx.fill(); }

  function drawWheel(x, y, r, spin) {
    disc(x, y, r, "#1a1a1e");
    disc(x, y, r - 2, "#3a3a42");
    disc(x, y, r - 4, "#0b0b0e");
    var a = spin % (Math.PI * 2);
    ctx.strokeStyle = "#8a8a94"; ctx.lineWidth = 1; ctx.beginPath();
    ctx.moveTo(x + Math.cos(a) * (r - 3), y + Math.sin(a) * (r - 3));
    ctx.lineTo(x - Math.cos(a) * (r - 3), y - Math.sin(a) * (r - 3)); ctx.stroke();
  }

  function drawBike(bx, gy, bob, spin) {
    // The bike is grey and black; only the rider wears red, so the two never
    // merge. Legs and gloves are light grey so they read against the engine.
    var y = gy + bob, K = "#151518", G = "#4a4a56", L = "#c4c4cc", R = "#ff2b2b";
    drawWheel(bx, y - 7, 7, spin);
    drawWheel(bx + 28, y - 7, 7, spin);
    px(bx + 2, y - 10, 10, 2, "#8a8a94");            // swingarm to the rear axle
    px(bx + 8, y - 17, 15, 9, "#26262d");            // engine block
    px(bx + 10, y - 15, 4, 5, "#3a3a44");
    px(bx + 4, y - 9, 12, 2, "#8a8a94");             // exhaust
    ctx.strokeStyle = "#8a8a94"; ctx.lineWidth = 2; ctx.beginPath();
    ctx.moveTo(bx + 28, y - 8); ctx.lineTo(bx + 25, y - 20); ctx.stroke();   // fork
    px(bx + 23, y - 22, 9, 2, "#8a8a94");            // handlebar
    px(bx + 12, y - 22, 11, 6, G);                   // tank
    px(bx + 12, y - 20, 11, 1, "#e6e6ea");           // tank stripe
    px(bx + 3, y - 21, 10, 4, K);                    // seat
    px(bx - 1, y - 20, 5, 3, G);                     // tail
    px(bx - 2, y - 19, 2, 2, R);                     // tail light
    px(bx + 31, y - 19, 2, 3, "#fff6c2");            // headlight
    // rider: light legs on the dark engine, red jacket on the grey bike
    ctx.strokeStyle = L; ctx.lineWidth = 3; ctx.lineCap = "butt";
    ctx.beginPath(); ctx.moveTo(bx + 8, y - 20); ctx.lineTo(bx + 17, y - 15); ctx.stroke();   // thigh
    ctx.beginPath(); ctx.moveTo(bx + 17, y - 15); ctx.lineTo(bx + 15, y - 8); ctx.stroke();   // shin
    px(bx + 13, y - 9, 7, 3, "#e6e6ea");             // boot on the peg
    ctx.fillStyle = R; ctx.beginPath();              // torso
    ctx.moveTo(bx + 5, y - 21); ctx.lineTo(bx + 8, y - 34); ctx.lineTo(bx + 17, y - 33); ctx.lineTo(bx + 21, y - 24); ctx.lineTo(bx + 13, y - 21); ctx.closePath(); ctx.fill();
    ctx.strokeStyle = R; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.moveTo(bx + 16, y - 30); ctx.lineTo(bx + 25, y - 23); ctx.stroke();  // arm to the bar
    px(bx + 24, y - 25, 4, 3, "#e6e6ea");            // glove
    disc(bx + 20, y - 37, 5, "#fff");                // helmet
    px(bx + 20, y - 38, 6, 3, K);                    // visor
    ctx.lineCap = "butt";
  }

  function drawCop(cx, gy, frame, spin) {
    var y = gy;
    // black and white cruiser, read against a near-black ground by its grey shell
    px(cx - 54, y - 13, 54, 10, "#4a4a56");           // shell
    px(cx - 54, y - 4, 54, 2, "#1a1a1e");             // sill
    px(cx - 40, y - 13, 24, 9, "#e6e6ea");            // white doors
    px(cx - 54, y - 6, 54, 2, "#2c2c34");             // body line
    ctx.fillStyle = "#3a3a44"; ctx.beginPath();       // cabin
    ctx.moveTo(cx - 45, y - 13); ctx.lineTo(cx - 38, y - 22); ctx.lineTo(cx - 15, y - 22); ctx.lineTo(cx - 8, y - 13); ctx.closePath(); ctx.fill();
    px(cx - 37, y - 20, 9, 6, "#12121a");             // windows
    px(cx - 26, y - 20, 10, 6, "#12121a");
    px(cx - 16, y - 20, 1, 6, "#3a3a44");
    px(cx - 3, y - 11, 3, 2, "#fff6c2");              // headlight
    px(cx - 54, y - 11, 2, 2, "#ff2b2b");             // tail light
    px(cx - 2, y - 5, 2, 2, "#1a1a1e");               // bumper
    drawWheel(cx - 43, y - 5, 5, spin);
    drawWheel(cx - 12, y - 5, 5, spin);
    // lightbar
    var on = Math.floor(frame / 6) % 2 === 0;
    px(cx - 34, y - 26, 16, 4, "#1a1a1e");
    px(cx - 33, y - 25, 7, 2, on ? "#ff2b2b" : "#5a1010");
    px(cx - 25, y - 25, 7, 2, on ? "#2b5cff" : "#101a5a");
    if (!reduce || on) {
      ctx.globalAlpha = .22;
      disc(cx - 30, y - 24, 18, on ? "#ff2b2b" : "#2b5cff");
      ctx.globalAlpha = 1;
    }
  }

  function draw() {
    var s = scene;
    px(0, 0, W, H, "#050506");
    // low-left red glow, the plate's own motif
    var g = ctx.createRadialGradient(20, H, 0, 20, H, 170);
    g.addColorStop(0, "rgba(255,43,43,.22)"); g.addColorStop(1, "rgba(255,43,43,0)");
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    // hairline grid drifting behind everything
    ctx.fillStyle = "rgba(255,255,255,.05)";
    for (var gx = -(s.sky % 32); gx < W; gx += 32) ctx.fillRect(Math.round(gx), 0, 1, GY);
    for (var gy2 = 24; gy2 < GY; gy2 += 32) ctx.fillRect(0, gy2, W, 1);
    // skyline, slow parallax
    ctx.fillStyle = "#0d0d11";
    for (var i = 0; i < skyline.length; i++) {
      var b = skyline[i], x = ((b.x - s.far) % (W * 2) + W * 2) % (W * 2) - W;
      ctx.fillRect(Math.round(x), GY - 12 - b.h, b.w, b.h + 12);
    }
    // road
    px(0, GY - 12, W, 1, "#232329");
    px(0, GY - 11, W, H - GY + 11, "#0b0b0e");
    px(0, GY + 4, W, 1, "#141418");
    ctx.fillStyle = "#3a3a42";
    for (var dx = -(s.road % 40); dx < W; dx += 40) ctx.fillRect(Math.round(dx), GY + 10, 18, 2);
    px(0, H - 2, W, 2, "#232329");
    // speed streaks while boosting
    if (s.boost > 0) {
      ctx.fillStyle = "rgba(255,255,255," + Math.min(.6, s.boost / 400) + ")";
      for (var k = 0; k < 7; k++) {
        var sy = 30 + ((k * 37 + Math.floor(s.t / 60)) % (GY - 30));
        var sx = ((k * 91 + s.t * 1.7) % (W + 60)) - 60;
        ctx.fillRect(Math.round(sx), sy, 26 + k * 3, 1);
      }
    }
    var spin = reduce ? 0 : s.odo / 7;
    var bob = reduce ? 0 : (Math.floor(s.odo / 24) % 2);
    if (s.copX > -70) drawCop(s.copX, GY + 2, reduce ? 0 : Math.floor(s.t / 16), spin);
    drawBike(s.bikeX, GY + 2, bob, spin);
    // siren wash after a wrong answer
    if (s.siren > 0) {
      var red = Math.floor(s.t / 90) % 2 === 0;
      ctx.fillStyle = red ? "rgba(255,43,43,.16)" : "rgba(43,92,255,.16)";
      ctx.fillRect(0, 0, W, H);
    }
  }

  function step(now) {
    var s = scene;
    var dt = s.last ? Math.min(50, now - s.last) : 16; s.last = now;
    if (!reduce) {
      var v = s.speed + (s.boost > 0 ? 3 : 0);
      s.t += dt; s.odo += v * dt / 16; s.road += v * dt / 16; s.sky += v * .25 * dt / 16; s.far += v * .5 * dt / 16;
      s.copX += (s.copTarget - s.copX) * Math.min(1, dt / 160);
      s.bikeX += s.bikeVX * dt / 16;
      if (s.boost > 0) s.boost -= dt;
      if (s.siren > 0) s.siren -= dt;
    }
    draw();
    s.raf = requestAnimationFrame(step);
  }
  function running(on) {
    if (reduce) { draw(); return; }
    if (on && !scene.raf) { scene.last = 0; scene.raf = requestAnimationFrame(step); }
    if (!on && scene.raf) { cancelAnimationFrame(scene.raf); scene.raf = 0; }
  }
  // pause the loop while the scene is off screen or the tab is hidden
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) running(true); else running(false); });
    }, { threshold: 0 }).observe(el.canvas);
  } else { running(true); }
  document.addEventListener("visibilitychange", function () { if (!document.hidden) { scene.last = 0; } });

  /* ============================================================
     THE GAME
     ============================================================ */
  var game = { gap: START, n: 0, deck: [], asked: 0, locked: false, fuseRaf: 0, fuseEnd: 0, state: "idle" };

  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  function setGap(gap) {
    game.gap = Math.max(LOSE, Math.min(WIN, gap));
    var segs = el.meter.children;
    for (var i = 0; i < segs.length; i++) segs[i].className = i < game.gap ? "on" : "";
    el.meter.classList.toggle("hot", game.gap <= 1);
    scene.copTarget = copFor(game.gap);
    if (reduce) { scene.copX = scene.copTarget; draw(); }
  }

  function stamp(text, caught) {
    el.stampText.textContent = text;
    el.stamp.classList.toggle("caught", !!caught);
    el.stamp.classList.add("show");
    el.sr.textContent = text;
  }
  function unstamp() { el.stamp.classList.remove("show"); }

  function nextQuestion() {
    if (!game.deck.length) game.deck = shuffle(BANK.slice());
    var item = game.deck.pop();
    game.asked++;
    el.qn.textContent = "Q" + game.asked;
    el.q.textContent = item.q;
    el.answers.innerHTML = "";
    var opts = item.a.map(function (t, i) { return { t: t, ok: i === item.c }; }).slice(0, PICK);
    shuffle(opts);
    opts.forEach(function (o, i) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "chase__answer";
      b.innerHTML = "<b>" + String.fromCharCode(65 + i) + "</b><span></span>";
      b.lastChild.textContent = o.t;
      if (o.ok) game.rightText = o.t;
      b.addEventListener("click", function () { answer(b, o.ok); });
      el.answers.appendChild(b);
    });
    game.locked = false;
    show("q");
    fuse(TIME);
  }

  function fuse(ms) {
    cancelAnimationFrame(game.fuseRaf);
    game.fuseEnd = performance.now() + ms;
    el.timer.classList.remove("hot");
    el.fuse.style.transform = "scaleX(1)";
    (function tick(now) {
      var left = game.fuseEnd - now;
      if (game.locked) return;
      if (left <= 0) { el.fuse.style.transform = "scaleX(0)"; answer(null, false); return; }
      el.fuse.style.transform = "scaleX(" + (left / ms) + ")";
      if (left < 3000) el.timer.classList.add("hot");
      game.fuseRaf = requestAnimationFrame(tick);
    })(performance.now());
  }

  function answer(btn, ok) {
    if (game.locked) return;
    game.locked = true;
    cancelAnimationFrame(game.fuseRaf);
    var btns = el.answers.querySelectorAll("button");
    for (var i = 0; i < btns.length; i++) {
      btns[i].disabled = true;
      // the right answer is always revealed: on a miss, and on a timeout
      if (!ok && btns[i].lastChild.textContent === game.rightText) btns[i].classList.add("is-right");
    }
    if (btn) btn.classList.add(ok ? "is-right" : "is-wrong");
    if (!btn) el.sr.textContent = "Out of time.";
    track("answer", { chase_ok: ok, chase_gap: game.gap });
    if (ok) { scene.boost = 700; } else { scene.siren = 900; }
    setTimeout(function () {
      setGap(game.gap + (ok ? 1 : -1));
      if (game.gap >= WIN) return setTimeout(escaped, 500);
      if (game.gap <= LOSE) return setTimeout(caught, 600);
      setTimeout(nextQuestion, 350);
    }, 550);
  }
  function start() {
    unstamp();
    game.deck = shuffle(BANK.slice()); game.asked = 0; game.state = "run";
    scene.mode = "run"; scene.bikeX = BIKE_X; scene.bikeVX = 0; scene.speed = 3; scene.boost = 0; scene.siren = 0;
    setGap(START);
    scene.copX = scene.copTarget;
    track("start");
    nextQuestion();
  }

  function escaped() {
    game.state = "won";
    scene.boost = 1400; scene.bikeVX = 5;
    stamp("You got away");
    store.set();
    gate("open");
    el.rk.textContent = "Clean getaway";
    el.rt.textContent = winner ? "You got away" : reward ? "You got away" : "The drop is open";
    el.rc.textContent = winner ? "Lock in your spot below and the drop password comes to your phone." : reward ? "That is the password. Type it in below and the drop opens." : "Rack unlocked. It stays unlocked on this phone.";
    showReward();
    el.again.hidden = true; el.shop.hidden = false; el.replay.hidden = false;
    show("result");
    track("escape", { chase_questions: game.asked });
    if (reward) return;
    setTimeout(function () {
      var rack = document.getElementById(winner ? "winner" : "rack");
      if (rack && rack.scrollIntoView) rack.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    }, 1400);
  }

  function caught() {
    game.state = "lost";
    scene.siren = 2400; scene.speed = 0; scene.boost = 0; scene.bikeVX = 0;
    stamp("Pulled over", true);
    el.rk.textContent = "Busted";
    el.rt.textContent = "They got you";
    el.rc.textContent = "Cruiser on your tail, lights in the mirror. Run it back from the start.";
    el.again.hidden = false; el.shop.hidden = true; el.replay.hidden = true;
    show("result");
    track("caught", { chase_questions: game.asked });
  }

  el.start.addEventListener("click", start);
  el.again.addEventListener("click", start);
  el.replay.addEventListener("click", start);

  function showReward() {
    if (!reward || !el.reward) return;
    el.rewardWord.textContent = reward;
    el.reward.hidden = false;
  }
  /* "Enter it": put the word in the password screen and take the visitor
     there. Typing it is still the visitor's tap on Unlock, per Mudit's
     wording ("which you can then enter in the same area"). */
  if (reward) el.shop.addEventListener("click", function (e) {
    var g = document.getElementById("gate");
    var input = g && g.querySelector("input[name=code]");
    if (!input) return;
    e.preventDefault();
    input.value = reward;
    if (g.scrollIntoView) g.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
    setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); } }, reduce ? 0 : 450);
    track("reward_fill");
  });

  /* ---------- boot ---------- */
  var plate = document.getElementById("plate");
  if (plate) plate.classList.add("plate--chase");
  scene.copTarget = copFor(START); scene.copX = scene.copTarget;
  setGap(START);
  if (store.get()) {
    gate("open");
    game.state = "won";
    scene.copX = scene.copTarget = copFor(WIN);
    el.rk.textContent = "Clean getaway";
    el.rt.textContent = winner ? "You got away" : reward ? "You got away" : "The drop is open";
    el.rc.textContent = winner ? "You already got away on this phone. Lock in your spot below if you have not, or run it again for the sport of it." : reward ? "You already got away on this phone. That is the password; type it in below, or run it again for the sport of it." : "You already got away on this phone. Shop the drop, or run it again for the sport of it.";
    showReward();
    el.again.hidden = true; el.shop.hidden = false; el.replay.hidden = false;
    show("result");
  } else {
    gate("locked");
    show("intro");
  }
  draw();
})();
